import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useState } from "react";
import { IMajorTech } from "../../models/MajorTech";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IUserMast } from "../../models/UserMast";
import { ILogin, IPermissionProps } from "../../models/Login";
import { AttendanceHistoryTable } from "../attendanceMark/Table";
import { JVDropdown } from "../../shared/JVDropdown";
import { ISkillCategoriesDropdown } from "../../models/IDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { InputText } from "primereact/inputtext";
import { ITeamManagement } from "../../models/TeamManagement";


interface IProps {
    singledata: any,
    open: boolean,
    hideHistory: () => void,
    toast: any,
    permissions?: IPermissionProps
};

interface ITeamMembersDetails {
    team_ID?: number,
    user_Name?: string,
    login_ID?: number,
    branch_ID?: number,
    branchName?: string,
    req_CategoryID?: number,
    req_CategoryName?: string,
    is_Allocate?: boolean,
    allocation_Order?: number,
    temp_Inactive?: boolean,
    user_Status?: boolean,
}

const schema = yup.object({
    req_Category: yup.string().required("Skills Category is required"),

});

export const SkillCategoryTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [attendanceTable, setAttendanceTable] = useState({ user_id: 0, open: false } as { user_id: number, open: boolean });
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();

    const { control, handleSubmit, reset, watch, formState: { errors } } = useForm<ITeamManagement>({
        resolver: yupResolver(schema),
        shouldFocusError: false
    });
    const leftToolbarTemplate = () => {
        return <></>
    };

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const onHideHistoryTable = () => {
        setAttendanceTable({ user_id: 0, open: false });
    }

    const toggleVal = async (login_id: number, toggle_type: number) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("User_Mast/toggle", "PUT", null, `login_id=${login_id}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            // let message: string = toggle_type === 1 ? "User Status Changed" : toggle_type === 2 ? "Temp Status Changed" : "Work From Changed";
            let message: string = "User Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            getTeamMembersDetails();
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const user_TStatus = (rowData: IUserMast) => {
        return (
            <span style={{ color: rowData.temp_Inactive ? 'red' : 'green' }} className="cursor-pointer" onClick={() => { if (rowData.login_ID && (_roles.includes(1) || _roles.includes(4))) toggleVal(rowData.login_ID, 2) }}>{rowData.temp_Inactive ? "No" : "Yes"}</span>
        );
    };

    const onHide = () => {
        props.hideHistory();
    }

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    const getTeamMembersDetails = async (categoryID?: number) => {
        let query = `team_id=${props.singledata.team_ID}`;
        if(categoryID){
            query = query+ `&categoryID=${categoryID}`;
        }
        const response = await Fetch("TeamMember_Skill_Mast/teamMembersDetails", "GET", null, query, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const loadSelecetdSkillCategories = async () => {
        const response = await Fetch("Team_Skill_Mast/getSkillsCategories", "GET", null, `team_id=${props.singledata.team_ID}`, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    useEffect(() => {
        if (props.open) { getTeamMembersDetails(); loadSelecetdSkillCategories(); }
    }, [props.open]);

    const onSubmit = (data: any) => {
        if (data.req_Category == null) {
            props.toast.current.show({ severity: 'error', detail: "Please select ", life: 3000 });
        } else {
            getTeamMembersDetails(data.req_Category);
        }
    }



    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Skills Team Management" modal className="p-fluid" onHide={onHide}>

            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid ">
                <JVDropdown required column={2} label="Skills Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Skills Category" />
                <div className="field col-12 md:col-2">
                    <label htmlFor="">&nbsp;</label>
                    <Button type="submit" icon="pi pi-search" className="mt-5 -ml-5 p-button-warning" />
                </div>
            </form>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="No Data found."
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="user_Name" header="Name" />
                <Column field="branchName" header="Branch" />
                <Column field="req_CategoryName" header="Category Name" />
                <Column field="is_Allocate" header="Allocation" body={(e) => <p style={{ color: e.is_Allocate ? 'green' : 'red' }}>{e.is_Allocate ? "Yes" : "No"}</p>} />
                <Column field="temp_Inactive" header="Present" body={user_TStatus} />
                <Column field="user_Status" header="Status" body={(rowData) => <span style={{ color: rowData.user_Status ? 'red' : 'green' }}>{rowData.user_Status ? "Inactive" : "Active"}</span>} />
                {(_roles.includes(1) || _roles.includes(4)) && <Column header="History" body={(rowData) => <i className="cursor-pointer text-primary pi pi-clock" onClick={() => setAttendanceTable({ user_id: rowData.login_ID, open: true })}></i>} />}
            </DataTable>
            <div className="field col-12 md:col-6 w-full">
                <Button className="p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
            </div>
            <Dialog visible={attendanceTable.open} style={{ width: '80vw' }} header="History" modal className="p-fluid" onHide={onHideHistoryTable} >
                {props.permissions?.is_View && <AttendanceHistoryTable user_ID={attendanceTable.user_id} />}
            </Dialog>
        </Dialog>
    );
}